export default class Lock {
	constructor(objId) {
		(this.objId = objId), (this.intervalId = null);
	}
}
